import { render, staticRenderFns } from "./org_course_plan.vue?vue&type=template&id=1f757f5e&scoped=true"
import script from "./org_course_plan.vue?vue&type=script&lang=js"
export * from "./org_course_plan.vue?vue&type=script&lang=js"
import style0 from "./org_course_plan.vue?vue&type=style&index=0&id=1f757f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f757f5e",
  null
  
)

export default component.exports